/**
 * Automy.Core.Enums.Reporting.Filters.ReportFilterBehavior
 * Native filter JSON `behavior` (string token). Required on every filter.
 * No Runtime. Viewer runtime choices are not persisted here.
 */
export default Object.freeze({
  Fixed: 'fixed',
  Available: 'available',
  Context: 'context',
});
